function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { PageEmbeddedApp } from "../page/apps";
import { PageToolbarController } from "../page/toolbar";
import { UtilityComponent } from "../../library/components/base";
import { TinyRichEditor } from "../../library/cms/editor";
import { MDCTextInput } from "../../library/components/mdc-components";

class CareerEditDetail extends UtilityComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onEditorChange", content => {
      var item = this.props.item;
      item.description = content;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onTitleChange", event => {
      var item = this.props.item;
      item.title = event.target.value;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onLocationChange", event => {
      var item = this.props.item;
      item.location = event.target.value;
      this.props.onStateChange('item', item);
    });

    _defineProperty(this, "onContactChange", event => {
      var item = this.props.item;
      item.contact = event.target.value;
      this.props.onStateChange('item', item);
    });
  }

  render() {
    return /*#__PURE__*/React.createElement("section", {
      className: "career-detail active form",
      role: "region"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "italic"
    }, this.props.item.title), /*#__PURE__*/React.createElement("div", {
      className: "card"
    }, /*#__PURE__*/React.createElement("h5", null, "Job Title:"), /*#__PURE__*/React.createElement(MDCTextInput, {
      value: this.props.item.title,
      label: "Title",
      onChange: this.onTitleChange
    }), /*#__PURE__*/React.createElement("h5", null, "Location:"), /*#__PURE__*/React.createElement(MDCTextInput, {
      value: this.props.item.location,
      label: "Location",
      onChange: this.onLocationChange
    }), /*#__PURE__*/React.createElement("h5", null, "Contact:"), /*#__PURE__*/React.createElement(MDCTextInput, {
      value: this.props.item.contact,
      label: "Contact",
      onChange: this.onContactChange
    }), /*#__PURE__*/React.createElement("h5", null, "Date Posted:"), /*#__PURE__*/React.createElement("span", null, this.props.item.datePostedString)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TinyRichEditor, {
      addColors: "#ddd",
      content: this.props.item.description,
      active: true,
      onChange: this.onEditorChange,
      ref: ref => this.editor = ref,
      cls: "min-height"
    }));
  }

}

class CareerViewDetail extends UtilityComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    var item = this.props.item;
    var contactCss = 'show-contact';
    var contact = item.contact;
    if (!contact || contact === '-----') contactCss = 'hide';
    return /*#__PURE__*/React.createElement("section", {
      className: "career-detail"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "italic"
    }, item.title), /*#__PURE__*/React.createElement("div", {
      className: "card"
    }, /*#__PURE__*/React.createElement("h5", null, "Job Title:"), /*#__PURE__*/React.createElement("span", null, item.title), /*#__PURE__*/React.createElement("h5", null, "Location:"), /*#__PURE__*/React.createElement("span", null, item.location), /*#__PURE__*/React.createElement("h5", {
      className: contactCss
    }, "Contact:"), /*#__PURE__*/React.createElement("span", {
      className: contactCss
    }, contact), /*#__PURE__*/React.createElement("h5", null, "Date Posted:"), /*#__PURE__*/React.createElement("span", null, item.datePostedString)), /*#__PURE__*/React.createElement("div", {
      className: "content",
      dangerouslySetInnerHTML: this.rawMarkup(item.description)
    }));
  }

}

class CareerDetail extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onStateChange", (prop, value) => {
      this.state[prop] = value;
      this.setState(this.state);
    });

    this.state = {
      item: this.props.item
    };
  }

  getEntity() {
    var entity = this.state.item;
    return entity;
  }

  render() {
    if (this.props.active) {
      return /*#__PURE__*/React.createElement(CareerEditDetail, {
        item: this.state.item,
        onStateChange: this.onStateChange
      });
    } else {
      return /*#__PURE__*/React.createElement(CareerViewDetail, {
        item: this.state.item
      });
    }
  }

}

export default class CareersApp extends PageEmbeddedApp {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CareerDetail, {
      active: this.state.component.active,
      item: this.props.initialData.entity,
      ref: ref => this.component = ref
    }), /*#__PURE__*/React.createElement(PageToolbarController, {
      showToolbar: this.props.initialData.showToolbar,
      onCommand: this.onCommand.bind(this),
      mode: this.mode,
      authorized: this.props.initialData.authorized,
      ref: ref => this.toolbarController = ref,
      onCreateDialogAccept: this.onCreateDialogAccept.bind(this),
      onCreateDialogCancel: this.onCreateDialogCancel.bind(this),
      onSettingsDialogAccept: this.onSettingsDialogAccept.bind(this),
      onSettingsDialogCancel: this.onSettingsDialogCancel.bind(this)
    }));
  }

}